import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  isOpen: boolean;
}

const SyncButton: React.FC<IParams> = ({ isOpen }) => {
  const rootStore = useContext(RootStoreContext);
  const { user } = rootStore.userStore;
  const { isSynced, isSharing, attendingMeeting } = rootStore.playerStore;
  const { enableSync, disableShareSync } = rootStore.tenantStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  const handleClick = () => {
    if (!isSynced) enableSync();
    else disableShareSync();
  };

  const checkDisabledButton = () => {
    if (
      isSharing ||
      !attendingMeeting ||
      (attendingMeeting &&
        (!attendingMeeting.sharingUserId ||
          attendingMeeting.sharingUserId === user?.id))
    )
      return true;
    else return false;
  };

  return (
    <>
      {!checkDisabledButton() && (
        <>
          <Button
            id="sync"
            className={classNames(
              "navbarButton mr-2",
              isSynced ? "navbarButtonSynced" : "navbarButtonEnabled"
            )}
            color=""
            disabled={checkDisabledButton()}
            onClick={() => handleClick()}
          >
            <span className="font-size-80 font-weight-bold mr-2 d-none d-lg-inline-block">
              {t("navbar_sync_button")}
            </span>
            <i className="fas fa-sync align-middle fa-lg"></i>
          </Button>
        </>
      )}
    </>
  );
};

export default observer(SyncButton);
